module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/incorporadoras/modal/incorporadoras-modal.component.scss
// module id = ./src/app/pages/incorporadoras/modal/incorporadoras-modal.component.scss
// module chunks = main